<template>
    <div class="c-o-my-pages-section">
        <div class="c-o-my-pages-section__inner">
            <div class="o-wysiwyg u-margin-bottom-4">
                <h2 class="c-o-my-pages-section__heading">Kundomdömen</h2>
                <p>Här kan du se de omdömen som ditt företag har fått.</p>
            </div>
            <div class="c-o-my-pages-ratings">
                <div v-for="item in slicedRatings" :key="`${item.RatId}`" class="c-o-my-pages-ratings__wrapper">
                    <rating
                        :key="`rating-${item.RatId}`"
                        :rating="item"
                        :company="company"
                    >
                    </rating>
                    <atom-button
                        v-if="!item.Answer"
                        :icon="'chat'"
                        :key="`btn-${item.RatId}`"
                        class="c-a-button--theme-primary c-o-button--reply-rating"
                        :label="'Besvara omdöme'"
                        @buttonClicked="openAnswerModal(item)"
                    ></atom-button>
                </div>
                <pagination
                    :totalItemsProp="ratings.length"
                    :itemsPerPageProp="5"
                    :maxPagesToShowProp="5"
                    :currentPageProp="page"
                    @changed="goToPage"
                ></pagination>
            </div>
            <modal class="c-m-modal--small" v-if="showAnswerModal" @close="showAnswerModal = false">
                <answer-rating-form :selectedRating="selectedRating" :company="company" />
            </modal>
        </div>
    </div>
</template>
<script>
    import Pagination from '../../../../molecules/MoleculePagination.vue'
    import Rating from '../../../../molecules/MoleculeRating.vue'

    import AtomButton from '../../../../atoms/AtomButton.vue'
    import Modal from '../../../../molecules/MoleculeModal.vue'
    import AnswerRatingForm from './OrganismAnswerRatingForm.vue'

    export default {
        props: [
            'ratings',
            'company'
        ],
        components:{
            Rating,
            Pagination,
            AtomButton,
            Modal,
            AnswerRatingForm
        },
        data() {
            return {
                page: 1,
                showAnswerModal: false,
                selectedRating: null,
            }
        },
        computed: {
            slicedRatings: function(){
                if (this.ratings.length <= 5) {
                    return this.ratings
                } else {
                    return this.ratings.slice((5 * this.page) - 5, 5 * this.page);
                }
            }
        },
        methods:{
            goToPage(page) {
                this.page = page;
            },
            openAnswerModal(item){
                this.selectedRating = item;
                this.showAnswerModal = true;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/company/profile/OrganismMyPagesRatings.vue